// Builds a CSV file from rows of data and triggers a browser download.
// rows: array of objects; headers: [{ key, label }]
export default function downloadCsv(filename, headers, rows) {
    const escape = (val) => {
        const s = val === null || val === undefined ? "" : String(val);
        return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };

    const headerLine = headers.map((h) => escape(h.label)).join(",");
    const lines = rows.map((row) => headers.map((h) => escape(row[h.key])).join(","));
    const csv = [headerLine, ...lines].join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
